var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDevice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223310"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223323",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.993 0H10.505A10.5 10.5 0 0 0 0 10.48v15.933a10.477 10.477 0 0 0 10.48 10.48h9a2.509 2.509 0 0 1 2.5 2.5v2.051a2.509 2.509 0 0 1-2.5 2.5h-5.623a1.776 1.776 0 0 0 0 3.552h19.834a1.776 1.776 0 1 0 0-3.552h-5.628a2.509 2.509 0 0 1-2.5-2.5v-2.05a2.509 2.509 0 0 1 2.5-2.5h8.929a10.477 10.477 0 0 0 10.48-10.48V10.48A10.493 10.493 0 0 0 36.993 0Z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Vector",
  d: "M44.097 18.759H30.863c-4.324 0-5.9 1.576-5.9 5.953v19.334c0 4.4 1.551 5.953 5.9 5.953h13.234c4.327 0 5.9-1.576 5.9-5.953V24.712c.003-4.402-1.548-5.953-5.9-5.953Zm-6.6 27.063a2.751 2.751 0 1 1 2.751-2.751 2.743 2.743 0 0 1-2.754 2.751Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Vector",
  d: "M40.242 43.07a2.751 2.751 0 1 1-2.749-2.751 2.743 2.743 0 0 1 2.749 2.751Z",
  opacity: 0.4
})))));
export default SvgDevice;